import appReducer from "./features/appSlice";
import { configureStore } from "@reduxjs/toolkit";
import notificationReducer from "./features/notification/notificationSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    notification: notificationReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
